module.exports = __webpack_public_path__ + "static/media/close_white.d00af346.svg";